export const namespaced = true;

const initState = () => ({
  users: [],
  pagination: { total: 0, page: 1, limit: 20, totalPages: 0 },
  isLoading: false,
  error: null,
});

export const state = initState();

export const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = { ...pagination };
  },
  SET_LOADING(state, val) {
    state.isLoading = val;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAN_STATE(state) {
    Object.assign(state, initState());
  },
};

export const actions = {
  cleanState({ commit }) {
    commit("CLEAN_STATE");
  },

  async fetchSysadminUsers({ commit }, params) {
    try {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      const restClient = require("../../lib/restClient").default;
      const { data } = await restClient.get("/api/v1/users", { params });
      commit("SET_USERS", data.users);
      commit("SET_PAGINATION", data.pagination);
      return data;
    } catch (error) {
      commit("SET_ERROR", error?.response?.data?.error || "UNKNOWN_ERROR");
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

export const getters = {
  getUsers: (state) => state.users,
  getPagination: (state) => state.pagination,
  isLoading: (state) => state.isLoading,
};
